import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

class VideoTitle extends React.Component {
  constructor() {
    super();

    this.state = {
      show: false,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        show: true,
      });
    }, 1400);
  }
  render() {
    const { show } = this.state;
    const { page } = this.props;
    return (
      <div className="w-100 text-center">
        <h2 className={`${show ? 'animated fadeInLeft TitleDelay' : ''}`}>
          {get(page, 'header_text[0].heading')}&nbsp;<br />
          <span>{get(page, 'header_text[0].subheading')}</span>
        </h2>
      </div>
    );
  }
}

VideoTitle.propTypes = {
  page: PropTypes.object.isRequired,
};

export default VideoTitle;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/VideoTitle.js